import { useEffect, useState } from "react";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "../lib/api";

export default function PaypalCheckout({ email, onSuccess }) {
  const [config, setConfig] = useState(null);

  useEffect(() => {
    api.get("/paypal/config").then((res) => setConfig(res.data)).catch(() => {});
  }, []);

  const emailValid = /^\S+@\S+\.\S+$/.test(email || "");

  if (!config?.clientId) {
    return <div className="h-12 rounded-full bg-sage/60 animate-pulse" data-testid="paypal-loading" />;
  }

  return (
    <div data-testid="paypal-buttons">
      <PayPalScriptProvider
        options={{ clientId: config.clientId, currency: config.currency || "EUR", intent: "capture" }}
      >
        <PayPalButtons
          style={{ layout: "horizontal", color: "gold", shape: "pill", label: "pay", height: 48, tagline: false }}
          forceReRender={[email]}
          disabled={!emailValid}
          createOrder={async () => {
            if (!emailValid) {
              toast.error("Introduce un email válido antes de pagar.");
              throw new Error("invalid email");
            }
            const { data } = await api.post("/paypal/create-order", { email: email.toLowerCase().trim() });
            return data.order_id;
          }}
          onApprove={async (data) => {
            try {
              const { data: res } = await api.post("/paypal/capture-order", { order_id: data.orderID });
              if (res.paid) {
                onSuccess({ email: res.email, accountExists: res.account_exists });
              } else {
                toast.error("El pago no se completó. Inténtalo de nuevo.");
              }
            } catch (e) {
              toast.error(formatApiErrorDetail(e.response?.data?.detail));
            }
          }}
          onError={() => toast.error("Hubo un problema con PayPal. Inténtalo de nuevo.")}
        />
      </PayPalScriptProvider>
    </div>
  );
}
